<template>
    <v-dialog v-model="abrirDialog" max-width="580px" class="pa-5" persistent>
        <v-card>
            <v-btn icon class="close-btn" @click="abrirDialog = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-card-title class="text-h5 font-weight-bold text-h5" color="primary">Quantidade de cotas no grupo excedida</v-card-title>
            <br>
            <v-card-text>
                <p class="text-body-1 texto">
                    Caro parceiro, seu <b>cliente ultrapassou a quantidade de cotas permitidas nesse grupo.</b>
                </p>
                <p class="text-body-1 texto">
                    <b>OBS: Essa verificação soma a quantidade de cotas ativas no grupo do cônjuge/sócio caso tenha.</b>
                </p>
                <br><br>
                <div class="d-flex align-center my-4">
                    <div class="mr-4">
                        <div class="texto-limite-atual">Qtd. cotas no grupo:</div>
                        <br>
                        <div class="text-primary texto-valor-lmite-atual">{{ cotasAtivasGrupo }}</div>
                    </div>
                    <v-icon mid class="mx-8">mdi-arrow-right</v-icon>
                    <div class="ml-4">
                        <div class="texto-limite-credito">Qtd. cotas do seu cliente:</div>
                        <br>
                        <div class="primary--text texto-valor-limite-credito">{{ cotasAtivasCliente }}</div>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn id="btn-fechar-dialog" color="primary" @click="abrirDialog = false">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    props: {
      visivel: {
        type: Boolean,
        required: true
      },
      cotasAtivasGrupo: {
        type: Number,
        required: true
      },
      cotasAtivasCliente: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        abrirDialog: this.visivel
      }
    },
    watch: {
      visivel (newValue) {
        this.abrirDialog = newValue
      },
      abrirDialog (newValue) {
        if (newValue === false) {
          this.$emit('fecharInformativoQuantidadeCotasDisponiveis', newValue)
        }
      }
    },
    methods: {
      fecharDialog () {
        this.abrirDialog = false
      }
    }
  }
</script>

<style scoped>
.texto {
  font-size: 1.2rem;
  line-height: 1.6;
}
.texto-limite-atual {
  font-size: 1.2rem;
  font-weight: bold;
}
.texto-valor-lmite-atual {
  font-size: 1.4rem;
  font-weight: bold;
}
.texto-limite-credito {
  font-size: 1.2rem;
  font-weight: bold;
}
.texto-valor-limite-credito {
  font-size: 1.4rem;
  font-weight: bold;
}
.v-dialog {
  padding: 24px;
}
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
}
.v-icon.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}
</style>
